import { useQueryClient } from '@tanstack/react-query';
import { useMutation } from 'query';
import { changeRequest } from 'common/services';
import { getProgramQueryKey } from '../keys';

export const useCreateRequestToJoinQuery = () => {
  const queryClient = useQueryClient();

  return useMutation<
    undefined,
    {
      data: { reason: string };
      programId: string;
    }
  >({
    async mutationFn({ data, programId }) {
      /* eslint-disable @typescript-eslint/naming-convention -- Start: We missing correct application model in camelCase, we need to fix it */
      await changeRequest({
        kind: 'program_request_to_join',
        meta: {
          reason_to_join: data.reason,
        },
        subject_id: programId,
        subject_type: 'Program',
      });
      /* eslint-enable @typescript-eslint/naming-convention -- End: We missing correct application model in camelCase, we need to fix it */

      return undefined;
    },
    onSuccess(_data, { programId }) {
      void queryClient.invalidateQueries({ queryKey: getProgramQueryKey({ programId }) });
    },
  });
};
